import axios from "../http";

class InvoicedGoodsServices {
  // 开票商品或劳务名称列表
  static getInvoicedGoodsServicesList(params = {}) {
    const url = `/zwy/api/cb/logistics/project/goods/receipt/list`;
    return axios.get(url, { params }).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 新增开票商品或劳务名称列表
  static postAddIvoicedGoodsServices(data) {
    const url = `/zwy/api/cb/logistics/project/save/goods/receipt`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 编辑开票商品或劳务名称列表
  static postUpdateIvoicedGoodsServices(id, data) {
    const url = `/zwy/api/cb/logistics/project/update/goods/receipt/${id}`;
    return axios.post(url, data).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 开启/关闭开票商品或劳务名称列表
  static postUpdatIvoicedGoodsServicesStatus(id) {
    const url = `/zwy/api/cb/logistics/project/update/goods/receipt/status/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
  // 删除开票商品或劳务名称
  static postDeleteIvoicedGoodsServices(id) {
    const url = `/zwy/api/cb/logistics/project/delete/goods/receipt/${id}`;
    return axios.post(url).then(res => {
      return Promise.resolve(res.data);
    });
  }
}

export default InvoicedGoodsServices;
